// extracted by mini-css-extract-plugin
export default {"nofilter":"Cvl_nofilter__2OAuc"};